import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		routes: [],
		imageUrl: ''
	},
	mutations:{
		initRoutes(state, data){
			state.routes = data;
		},
		setImageUrl(state,imageUrl){
			state.imageUrl = imageUrl
		}
	},
	actions:{
		
	}
	
	
});